import React, { Component } from "react";
import styled from "styled-components";
import { Switch, Route } from "react-router-dom";
import Stepper from "react-stepper-horizontal";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";

import OBOne from "./onboardingOne";
import OBTwo from "./onboardingTwo";
import OBThree from "./onboardingThree";
import OBFour from "./onboardingFour";
import OBFive from "./onboardingFive";

const Background = styled.div`
  width: 100%;
  height: 100%;
  background-color: white;
  position: relative;
  height: 100vh;
  text-align: center;
`;

const Inner = styled.div`
  width: 600px;
  margin: 35px auto;
`;

const Shell = styled.div`
  box-sizing: border-box;
  overflow: auto;
  width: 500px;
  padding: 30px 50px;
  text-align: center;
  border-radius: 6px;
  margin: 35px auto 35px auto;

  h2 {
    font-size: 18px;
    color: #5a5858;
    font-weight: 400;
    letter-spacing: 0.7px;
    line-height: 14px;
  }

  a {
    display: block;
    font-size: 12px;
    margin-bottom: 20px;

    &.reject {
      font-family: Roboto-Light;
      color: #c0c0c0;
      letter-spacing: 0.78px;
    }
  }
`;

class OnBoarding extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeStep: 0,
      allowTransition: true,
      steps: [
        { title: "Customer Data" },
        { title: "Billing Data" },
        { title: "Critical Event" },
        { title: "Usage Interval" },
        { title: "Next Steps" },
      ]
    };
  }

  componentDidMount() {
    if(this.props.isInterviewComplete) {
      this.props.changePage('/app/dashboard')
    } else {
      this.props.changePage('/setup')
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      switch (nextProps.location.pathname) {
        case "/setup/intercom":
          this.setState({ activeStep: 0 });
          break;
        case "/setup/billing":
          this.setState({ activeStep: 1 });
          break;
        case "/setup/success-metric-question":
          this.setState({ activeStep: 2 });
          break;
        case "/setup/usage-question":
          this.setState({ activeStep: 3 });
          break;
        case "/setup/success":
          this.setState({ activeStep: 4 });
          break;
        default:
          this.setState({ activeStep: 0 });
          break;
      }
    }
  }

  render() {
    let { match } = this.props;

    return (
      <Background>
        <Inner>
          <Stepper
            steps={this.state.steps}
            activeStep={this.state.activeStep}
            circleFontSize={12}
            titleFontSize={10}
            defaultColor={"#e8e8e8"}
            activeColor={"#34A8F0"}
            completeColor={"#34A8F0"}
            completeOpacity={"0.3"}
            completeBarOpacity={"0.3"}
            completeTitleOpacity={"0.3"}
            completeBarColor={"#34A8F0"}
            circleTop={10}
            titleTop={10}
          />
          <Shell>
            <Switch>
              <Route exact path={`${match.path}`} component={OBOne} />
              <Route path={`${match.path}/intercom`} component={OBOne} />
              <Route path={`${match.path}/billing`} component={OBTwo} />
              <Route path={`${match.path}/success`} component={OBThree} />
              <Route
                path={`${match.path}/success-metric-question`}
                component={OBFour}
              />
              <Route path={`${match.path}/usage-question`} component={OBFive} />
            </Switch>
          </Shell>
        </Inner>
      </Background>
    );
  }
}

const mapStateToProps = state => {
  return {
    isInterviewComplete: state.interview.interviewComplete
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: location => push(location)
    },
    dispatch
  );

const OnBoardingOne = connect(mapStateToProps, mapDispatchToProps)(OnBoarding);

export default OnBoardingOne;



// WEBPACK FOOTER //
// ./src/containers/onBoard/index.js